import React from "react";
import { BranchPerformance as BranchPerformanceType } from "./dashboardType";


interface Props {
  data: BranchPerformanceType[];
}

const currency = (
  value: number
) =>
  new Intl.NumberFormat(
    "en-IN",
    {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }
  ).format(value || 0);

const BranchPerformance: React.FC<Props> = ({
  data,
}) => {
  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Branch Performance
      </h2>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-left text-sm">
          <thead>
            <tr className="border-b bg-gray-50">
              <th className="px-3 py-3">
                Zone
              </th>

              <th className="px-3 py-3">
                Branch
              </th>

              <th className="px-3 py-3">
                Customers
              </th>

              <th className="px-3 py-3">
                Children
              </th>

              <th className="px-3 py-3">
                Active
              </th>

              <th className="px-3 py-3">
                Revenue
              </th>

              <th className="px-3 py-3">
                Delivery %
              </th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-3 py-8 text-center text-gray-500"
                >
                  No branch data found.
                </td>
              </tr>
            ) : (
              data.map(
                (branch) => (
                  <tr
                    key={
                      branch.Branch_Code
                    }
                    className="border-b"
                  >
                    <td className="px-3 py-3">
                      <div className="font-medium">
                        {branch.Zone}
                      </div>

                      <div className="text-xs text-gray-500">
                        {
                          branch.Zone_Code
                        }
                      </div>
                    </td>

                    <td className="px-3 py-3">
                      <div className="font-medium">
                        {branch.Branch}
                      </div>

                      <div className="text-xs text-gray-500">
                        {
                          branch.Branch_Code
                        }
                      </div>
                    </td>

                    <td className="px-3 py-3">
                      {branch.Customers}
                    </td>

                    <td className="px-3 py-3">
                      {branch.Children}
                    </td>

                    <td className="px-3 py-3">
                      {branch.Active}
                    </td>

                    <td className="px-3 py-3 font-medium">
                      {currency(
                        branch.Revenue
                      )}
                    </td>

                    <td className="px-3 py-3">
                      {
                        branch.Delivery_Percentage
                      }
                      %
                    </td>
                  </tr>
                )
              )
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default BranchPerformance;